'use client';

import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useMemo } from 'react';
import { DEFAULT_THEME } from '../default-theme.mjs';
import { mergeMantineTheme } from '../merge-mantine-theme/merge-mantine-theme.mjs';
var MantineThemeContext = createContext(null);
var useSafeMantineTheme = function useSafeMantineTheme() {
  return useContext(MantineThemeContext) || DEFAULT_THEME;
};
function useMantineTheme() {
  var ctx = useContext(MantineThemeContext);
  if (!ctx) {
    throw new Error("@mantine/core: MantineProvider was not found in component tree, make sure you have it in your app");
  }
  return ctx;
}
function MantineThemeProvider(_ref) {
  var theme = _ref.theme,
    children = _ref.children,
    _ref$inherit = _ref.inherit,
    inherit = _ref$inherit === void 0 ? true : _ref$inherit;
  var parentTheme = useSafeMantineTheme();
  var mergedTheme = useMemo(function () {
    return mergeMantineTheme(inherit ? parentTheme : DEFAULT_THEME, theme);
  }, [theme, parentTheme, inherit]);
  return /* @__PURE__ */jsx(MantineThemeContext.Provider, {
    value: mergedTheme,
    children: children
  });
}
MantineThemeProvider.displayName = "@mantine/core/MantineThemeProvider";
export { MantineThemeContext, MantineThemeProvider, useMantineTheme, useSafeMantineTheme };